var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 1.25A3.75 3.75 0 0 0 .25 5v9.887c0 1.078 1.274 1.65 2.08.934l3.455-3.071H7.25V15A3.75 3.75 0 0 0 11 18.75h7.215l3.454 3.07c.807.717 2.081.145 2.081-.933V11A3.75 3.75 0 0 0 20 7.25h-3.25V5A3.75 3.75 0 0 0 13 1.25H4Zm11.25 6V5A2.25 2.25 0 0 0 13 2.75H4A2.25 2.25 0 0 0 1.75 5v9.33l3.11-2.764a1.25 1.25 0 0 1 .83-.316h1.56V11A3.75 3.75 0 0 1 11 7.25h4.25Zm7 3.75A2.25 2.25 0 0 0 20 8.75h-9A2.25 2.25 0 0 0 8.75 11v4A2.25 2.25 0 0 0 11 17.25h7.31c.306 0 .602.112.83.316l3.11 2.764V11Z",
    clipRule: "evenodd"
  })));
};
export default SvgChat;